import { useEffect, useState } from "react";
import { api, fmtDate, relTime } from "@/lib/api";
import { Link } from "react-router-dom";
import { Star, ArrowRight, Buildings } from "@phosphor-icons/react";

const RISK_BADGE = { critical: "badge-danger", high: "badge-danger", medium: "badge-warn", low: "badge-success" };

export default function Leads() {
  const [leads, setLeads] = useState([]);
  const load = async () => { const { data } = await api.get("/leads"); setLeads(data); };
  useEffect(() => { load(); }, []);

  const convert = async (id) => {
    await api.post(`/leads/${id}/convert`);
    load();
  };

  return (
    <div className="space-y-5" data-testid="leads-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="label-eyebrow">Inbound Pipeline</div>
          <h1 className="font-display text-[28px] font-bold tracking-tight mt-1">Brand Protection Leads</h1>
          <div className="text-[12px] text-[var(--span-text-2)] mt-1">From the public Brand Health Score — one click converts to a case + client.</div>
        </div>
        <Link to="/health-score" target="_blank" className="span-btn span-btn-ghost">
          View public form ↗
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {leads.length === 0 && <div className="text-[12px] text-[var(--span-text-2)]">No leads yet.</div>}
        {leads.map(l => (
          <div key={l.lead_id} className="card-flat p-5" data-testid={`lead-${l.lead_id}`}>
            <div className="flex items-start justify-between">
              <div>
                <div className="flex items-center gap-2">
                  <Buildings size={14} className="text-[var(--span-text-2)]"/>
                  <span className="font-display font-bold text-[17px]">{l.company_name}</span>
                </div>
                <div className="text-[11px] font-mono text-[var(--span-text-2)] mt-1">
                  {l.industry || "—"} · {l.country} · {l.contact_email}
                </div>
              </div>
              <div className="text-right">
                <div className="label-eyebrow">Exposure index</div>
                <div className="font-display font-bold text-[28px] tnum">{l.exposure_index}</div>
                <span className={`badge ${RISK_BADGE[l.risk_level]}`}>{l.risk_level}</span>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-3 gap-2">
              {Object.entries(l.sub_scores || {}).slice(0, 6).map(([k, v]) => (
                <div key={k} className="surface-2 p-2">
                  <div className="text-[9px] uppercase tracking-[0.16em] text-[var(--span-text-2)] truncate">{k.replace(/_/g, ' ')}</div>
                  <div className="font-mono text-[14px] font-semibold tnum">{v}</div>
                </div>
              ))}
            </div>

            <div className="mt-3 space-y-1">
              {(l.findings || []).slice(0, 3).map((f, i) => (
                <div key={i} className="text-[12px] text-[var(--span-text-2)]">• {f}</div>
              ))}
            </div>

            <div className="mt-4 flex items-center justify-between">
              <span className="text-[10px] font-mono text-[var(--span-text-2)]">{relTime(l.created_at)} · {fmtDate(l.created_at)}</span>
              {l.converted_to_case_id ? (
                <Link to={`/cases/${l.converted_to_case_id}`} className="badge badge-success font-mono">Converted →</Link>
              ) : (
                <button data-testid={`convert-${l.lead_id}`} onClick={() => convert(l.lead_id)} className="span-btn h-8 text-[11px]">
                  <Star size={11}/> Convert to case <ArrowRight size={11}/>
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
